/* @flow */
import Collection from 'lib/Collection';
import naturalSort from 'javascript-natural-sort';
import Widget from 'entities/Widget';

// $FlowIssue
class Widgets extends Collection<Widget> {
  initialize() {
    this.model = Widget;
    // $FlowIssue
    this.url = '/widgets';
  }

  // $FlowIssue
  comparator(a: Widget, b: Widget) {
    if (a.isAllClassesWidget()) {
      return -1;
    }

    if (b.isAllClassesWidget()) {
      return 1;
    }

    return naturalSort(a.getClassName().toLowerCase(), b.getClassName().toLowerCase());
  }
}

export default Widgets;
